'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const HeroMarketError = () => {
  return <ErrorDataUnavailable className="h-[303px] max-sm:h-[575px]" />
}

export default memo(HeroMarketError)
